export default "__VITE_ASSET__WMXkqDcp__"